import type { IGlobalState } from "./reducer/types";

/** Start a fresh workspace without carrying document IDs or filters across companies. */
export function getWorkCompanyLandingPath(host: IGlobalState["host"], search: string): string {
  if (host === "WEB") return "/";
  const params = new URLSearchParams(search);
  const raw = params.get("initOpts");
  if (!raw) throw new Error("Bitrix initialization is required");
  const options: unknown = JSON.parse(raw);
  if (
    !options ||
    typeof options !== "object" ||
    !("email" in options) ||
    typeof options.email !== "string" ||
    !options.email.trim() ||
    !("apiKey" in options) ||
    typeof options.apiKey !== "string" ||
    !options.apiKey
  ) {
    throw new Error("Invalid Bitrix initialization");
  }
  const next: { email: string; apiKey: string; displayScope?: string } = { email: options.email, apiKey: options.apiKey };
  if ("displayScope" in options) {
    if (
      typeof options.displayScope !== "string" ||
      !["ALL", "APPLICATIONS", "COMMERCIAL_OFFERS", "DEALS", "DEALS_TRACKING", "DEAL", "PAYMENT_REQUESTS"].includes(options.displayScope)
    ) {
      throw new Error("Invalid Bitrix display scope");
    }
    next.displayScope = options.displayScope;
  }
  return `/?${new URLSearchParams({ initOpts: JSON.stringify(next) }).toString()}`;
}
